export class PayOutError extends Error {}
